import { parsePhoneNumber } from 'libphonenumber-js';
import { ICheckoutAnyType } from '../components/common/types/CheckoutType';

export const handleMaxLengthCheck = (e: React.FormEvent<EventTarget>) => {
  const target = e.target as HTMLInputElement;
  if (target.value.length > target.maxLength) {
    target.value = target.value.slice(0, target.maxLength);
  }
};

export const filterArrayObjectByKeys = function (arr: Array<ICheckoutAnyType>, keys: Array<string>, search: string) {
  const lowSearch = search.toLowerCase();
  return arr.filter((item) => keys.some((key) => String(item[key]).toLowerCase().includes(lowSearch)));
};

export const addLeadingZero = (phoneNumber: string) => (phoneNumber.startsWith('0') ? phoneNumber : `0${phoneNumber}`);
export const removePhoneLeadingZero = (phoneNumber: string) =>
  phoneNumber.startsWith('0') ? phoneNumber.substring(1) : phoneNumber;

export const parseContactNumber = (phoneNumberStr: string, leadingZeroRequired: boolean) => {
  try {
    const obj = parsePhoneNumber(phoneNumberStr);
    return {
      countryCode: `+${obj?.countryCallingCode}` || '',
      phone:
        (obj?.nationalNumber &&
          (leadingZeroRequired ? addLeadingZero(obj.nationalNumber) : removePhoneLeadingZero(obj.nationalNumber))) ||
        '',
    };
  } catch (e) {
    return {
      countryCode: '',
      phone: phoneNumberStr,
    };
  }
};
